<template>
  <transition-group name="kmt" tag="div" class="kmt-stack">
    <div v-for="t in toasts" :key="t.id" class="kmt" :class="'kmt--'+t.type">
      <div class="kmt__icon">
        <svg v-if="t.type==='success'" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M9.55 17.58 4.2 12.23l1.41-1.41 3.94 3.93 8.84-8.84 1.41 1.42z"/></svg>
        <svg v-else-if="t.type==='error'" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12Z"/></svg>
        <svg v-else-if="t.type==='warn'" viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 2 1 21h22Zm0 5.5L19.5 19h-15Zm-1 5.5h2v4h-2Zm0 5h2v2h-2Z"/></svg>
        <svg v-else viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 15h-2v-6h2Zm0-8h-2V7h2Z"/></svg>
      </div>
      <div class="kmt__msg">{{ t.msg }}</div>
      <button v-if="t.dismissible" class="kmt__x" @click="dismiss(t.id)" aria-label="close">✕</button>
      <div class="kmt__bar"><div class="kmt__bar-fill" :style="{animationDuration: t.duration+'ms'}"></div></div>
    </div>
  </transition-group>
</template>

<script>
let _id = 0;

export default {
  name: 'KmToast',
  data(){ return { toasts: [] }; },
  mounted(){
    if(!window.$km) window.$km = {};
    window.$km.toast = (opts) => this.push(opts);
    // shortcuts
    ['success','error','warn','info'].forEach(t => {
      window.$km.toast[t] = (msg, opts={}) => this.push({ type: t, msg, ...opts });
    });
  },
  beforeDestroy(){
    if(window.$km && window.$km.toast) delete window.$km.toast;
  },
  methods:{
    push(opts){
      if(typeof opts === 'string') opts = { msg: opts };
      const id = ++_id;
      const t = {
        id,
        type: opts.type || 'info',
        msg: opts.msg || '',
        duration: opts.duration != null ? opts.duration : 3200,
        dismissible: opts.dismissible !== false
      };
      this.toasts.push(t);
      if(t.duration > 0){
        setTimeout(() => this.dismiss(id), t.duration);
      }
      return id;
    },
    dismiss(id){
      const i = this.toasts.findIndex(t => t.id === id);
      if(i !== -1) this.toasts.splice(i, 1);
    }
  }
}
</script>

<style>
/* Hide the legacy Vant toast globally — we have our own now. */
.van-toast { display: none !important; }
</style>

<style scoped>
.kmt-stack {
  position: fixed; top: 24px; left: 50%; transform: translateX(-50%);
  z-index: 10001; display: flex; flex-direction: column; gap: 10px;
  pointer-events: none; width: auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
}
.kmt {
  pointer-events: auto;
  display: flex; align-items: center; gap: 12px;
  min-width: 280px; max-width: 92vw; padding: 14px 18px;
  background: rgba(255,255,255,.85);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255,255,255,.7);
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(26,16,51,.18), 0 4px 12px rgba(26,16,51,.06);
  font-size: 14px; line-height: 1.4; color: #1a1033;
  position: relative; overflow: hidden;
}
.kmt__icon {
  width: 32px; height: 32px; flex-shrink: 0;
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  color: #fff;
}
.kmt--success .kmt__icon { background: linear-gradient(135deg,#34d399,#10b981); }
.kmt--error   .kmt__icon { background: linear-gradient(135deg,#f87171,#ef4444); }
.kmt--warn    .kmt__icon { background: linear-gradient(135deg,#fbbf24,#f59e0b); }
.kmt--info    .kmt__icon { background: linear-gradient(135deg,#ff4d8d,#a020f0); }

.kmt__msg { flex: 1; min-width: 0; font-weight: 500; }
.kmt__x {
  background: none; border: none; cursor: pointer; color: #8d7fa6;
  font-size: 14px; padding: 4px; border-radius: 6px; line-height: 1;
  transition: background .15s, color .15s;
}
.kmt__x:hover { background: rgba(26,16,51,.06); color: #1a1033; }

/* countdown bar */
.kmt__bar { position: absolute; left: 0; right: 0; bottom: 0; height: 3px; background: rgba(26,16,51,.06); }
.kmt__bar-fill {
  height: 100%; width: 100%;
  transform-origin: left center;
  animation: kmtCountdown linear forwards;
}
.kmt--success .kmt__bar-fill { background: linear-gradient(90deg,#34d399,#10b981); }
.kmt--error   .kmt__bar-fill { background: linear-gradient(90deg,#f87171,#ef4444); }
.kmt--warn    .kmt__bar-fill { background: linear-gradient(90deg,#fbbf24,#f59e0b); }
.kmt--info    .kmt__bar-fill { background: linear-gradient(90deg,#ff4d8d,#a020f0); }
@keyframes kmtCountdown {
  from { transform: scaleX(1); }
  to   { transform: scaleX(0); }
}

/* transitions */
.kmt-enter-active { transition: transform .35s cubic-bezier(.2,.9,.3,1.2), opacity .25s ease; }
.kmt-leave-active { transition: transform .25s ease, opacity .25s ease; position: relative; }
.kmt-enter { transform: translateY(-20px) scale(.95); opacity: 0; }
.kmt-leave-to { transform: translateY(-10px) scale(.95); opacity: 0; }
.kmt-move { transition: transform .35s ease; }

@media (max-width: 520px) {
  .kmt-stack { top: 16px; width: calc(100% - 24px); }
  .kmt { min-width: 0; width: 100%; padding: 12px 14px; font-size: 14px; border-radius: 14px; }
  .kmt__icon { width: 28px; height: 28px; }
}
</style>
